import React from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { LinearProgress, useMediaQuery } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import theme from './common/theme';
// eslint-disable-next-line no-unused-vars
import BottomMenu from './common/components/BottomMenu';
import { useEffectAsync } from './reactHelper';
import { sessionActions } from './store';
import OperatorCachingController from './OperatorCachingController';

const useStyles = makeStyles(() => ({
  page: {
    flexGrow: 1,
    overflow: 'auto',
  },
  menu: {
    zIndex: 1204,
  },
}));

const OperatorApp = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  // eslint-disable-next-line no-unused-vars
  const navigate = useNavigate();

  const desktop = useMediaQuery(theme.breakpoints.up('md'));

  const initialized = useSelector((state) => !!state.session.driver);

  useEffectAsync(async () => {
    if (!initialized) {
      const response = await fetch('/api/express/operators/session');
      if (response.ok) {
        dispatch(sessionActions.updateDriver(await response.json()));
      } else {
        navigate('/login/operator');
      }
    }
    return null;
  }, [initialized]);

  return !initialized ? (<LinearProgress />) : (
    <>
      <OperatorCachingController />
      <div className={classes.page}>
        <Outlet />
      </div>
      {!desktop && (
        <div className={classes.menu}>
          {/* <BottomMenu /> */}
        </div>
      )}
    </>
  );
};

export default OperatorApp;
